export default __webpack_public_path__ + "static/media/this-is-financial-communications-4.46738b0e.png";